<template>
  <div id="dashboard-content">
    <b-row class="">
        <b-col lg="7">
            <h1 class="page-title mb-3">
                Report Catalog
            </h1>
        </b-col>
    </b-row>

    <div class="mb-3 p-3 filters-container">
        <b-row class="">
            <b-col lg="4" md="6" sm="12">
                <v-select title="Topic" id="topic" :data="initData.topic" showHelp="true"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Funding Mechanism" id="fundingmechanism" :data="initData.fundingmechanism"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Year" id="year" :data="initData.year" :filter="selectedFilters"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Admin Institute/Center" id="ic" :data="initData.ic"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Activity" id="activity" :data="initData.activity"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12"></b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Portfolio" id="portfolio" :data="initData.portfolio"></v-select>
            </b-col>

            <b-col lg="4" md="6" sm="12">
                <v-select title="Variable" id="variable" :data="initData.variable" showHelp="true"></v-select>
            </b-col>
        </b-row>
        <b-row :class="mq.lg ? 'mt-3' : ''">
            <b-col class="text-end" lg="12" md="12" sm="12">
                <b-button variant="secondary" @click.prevent="clearSearch()">Reset</b-button>
                <b-button variant="primary" class="ms-2" @click.prevent="searchReport()">Search</b-button><b-link href class="ms-1" @click="setContentType(''); showModal()"><i class="fas fa-question-circle fa-sm"></i><span class="sr-only">help</span></b-link>
            </b-col>
        </b-row>
    </div>

    <b-row class="mt-2">
        <b-col>
            <div ref="tableComp">
                <div v-if="!isDataRequested" class="mx-1 fw-bold">To search for a specific report, please select the appropriate filters from the drop-down menus above, and click 'Search'.</div>
                <div class="text-center fw-bold" v-if="tableData && tableData.length > 0 && !isTblBusy">
                    <span class="records">{{tableData.length}}  records found.</span>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="tableData.length"
                        :per-page="perPage"
                        aria-controls="impact-reports-table"
                        align="right"
                        class="float-end"
                        v-if="isDataRequested"
                         @page-click="collapseMetaDataContainers"
                    ></b-pagination>
                </div>
                <v-table
                    isActive="true"
                    :customId="'catalogTable'"
                    :columns="columns"
                    :tableData="tableData"
                    ref="mainTable"
                    :isBusy="isTblBusy"
                    :class="isTblBusy ? 'isBusy' : ''"
                    :nestedTableColumns="columnsDrilldown"
                    :nestedTableData="tableDataDrilldown"
                    tableName="catalogRpts"
                    :pageSize="perPage"
                    :tablePageNo="currentPage"
                    v-show="isDataRequested && !serviceFailure"
                />
                <template v-if="isTblBusy">
                    <div class="loader"></div>
                </template>
                <div v-if="tableData && tableData.length > 0 && !isTblBusy" class="text-center border-top py-2"><span class="text-danger fw-bold">*</span> = Historical Report</div>
                <div v-if="serviceFailure">
                    <BAlert :model-value="true" variant="danger">{{ message }}</BAlert>
                </div>
            </div>

        </b-col>
    </b-row>
    <help-modal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import helpModal from "@/components/global/helpModal";
import vSelect from "@/components/global/_v-select.vue";
import vTable from '@/components/global/_v-table';
import * as axios from 'axios';
import { BaseURL } from "@/shared/config.js";
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";
import bus from '@/shared/event-bus.js';

export default {
    name: "DashboardFrr",
    inject: ["mq"],
    components: {
        helpModal,
        vSelect,
        vTable
    },
    computed: {
        ...mapGetters([
            'selectedFilters'
        ])
    },
    data: function () {
        return {
            contentType: "",
            tableID: "tableCS",
            frrAPIBaseUrl: "/api/frr/",
            searchParam: {
                activity_id: null,
                ic_id: null,
                mechanism_id: null,
                portfolio_id: null,
                variable_id: null,
                topic_id: null,
                year: null
            },
            columns: [
                {
                    label: " ",
                    key: "report_Id",
                    sortable: false,
                },
                {
                    label: "Report Title",
                    key: "report_Title",
                    sortable: true,
                    tdClass: 'reportTitle',
                    sortByFormatted: true,
                    formatter: (value) => {
                        return value.trim();
                    }
                },
                { label: "Topic", key: "topic", type: "", sortable: false },
                {
                    label: "Variable",
                    key: "variable",
                    sortable: false,
                },
                {
                    label: "Start Year",
                    key: "first_FY",
                    sortable: true,
                },
                {
                    label: "End Year",
                    key: "last_FY",
                    sortable: true,
                },
                {
                    label: "Download Report",
                    key: "version",
                    sortable: false,
                },
            ],
            initTableData: [],
            tableData: [],
            columnsDrilldown: [
                { label: "IC", key: "ic" },
                {
                    label: "Portfolio",
                    key: "portfolio"
                },
                {
                    label: "Mechanism",
                    key: "mechanism"
                },
                {
                    label: "Activity",
                    key: "activity"
                },
            ],
            tableDataDrilldown: [],
            initData: {
                variable: [],
                topic: [],
                year: [],
                ic: [],
                activity: [],
                fundingmechanism: [],
                portfolio: [],
            },
            initDataServices: [
                {
                    url:  "variable",
                },
                {
                    url:  "topic",
                },
                {
                    url:  "year",
                },
                {
                    url: "ic",
                },
                {
                    url:  "activity",
                },
                {
                    url:  "fundingmechanism",
                },
                {
                    url:  "portfolio",
                },
            ],
            responseMsg: "",
            isTblBusy: false,
            lookupBaseUrl: '${BaseURL}/api/lookup/',
            currentPage: 1,
            perPage: 25,
            isDataRequested: false,
            serviceFailure: false,
            message: SERVICE_UNAVAILABLE_ERROR_MSG
        };
    },
    async mounted () {
        var self = this,
            formattedData = [];

     	this.lookupBaseUrl = `${BaseURL}/api/lookup/`;
        self.responseMsg = "";
        self.initDataServices.forEach(async (value) =>  {
            let response = await axios.get(encodeURI(this.lookupBaseUrl + value.url));

            if (response && response.status === 200) {
                let data = response.data;

                if (value.url !== 'year') {
                    formattedData = [];
                    for (let i = 0; i < data.length; i++) {
                        formattedData.push({
                            value: data[i].id,
                            text: data[i].title
                        });
                    }
                    self.initData[value.url] = formattedData;
                } else {
                    self.initData[value.url] = data;
                }
            }
        });
        // self.loadReport();
        bus.$on('load:drilldowndata', async function (dataItem, dataIndex) {
            let isDataAvailable = await self.showDrillDownData(dataItem, dataIndex);
            bus.$emit('drilldowndata:loaded', isDataAvailable, dataIndex);
        });
    },

    methods: {
        ...mapActions([
            'setContentType',
            'clearSelectedFilters'
        ]),
        showModal () {
            bus.$emit('help:show');
        },
        async searchReport () {
            var self = this;

            try {
                self.serviceFailure = false;
                self.isDataRequested = true;
                self.responseMsg = "";
                if (self.selectedFilters && self.selectedFilters.ic) {
                    self.searchParam.ic_id = self.selectedFilters.ic;
                }
                else {
                    self.searchParam.ic_id = null;
                }
                if (self.selectedFilters && self.selectedFilters.year) {
                    self.searchParam.year = self.selectedFilters.year;
                }
                else {
                    self.searchParam.year = null;
                }
                if (self.selectedFilters && self.selectedFilters.topic) {
                    self.searchParam.topic_id =  self.selectedFilters.topic;
                }
                else {
                    self.searchParam.topic_id = null;
                }
                if (self.selectedFilters && self.selectedFilters.variable) {
                    self.searchParam.variable_id = self.selectedFilters.variable;
                }
                else {
                    self.searchParam.variable_id = null;
                }
                if (self.selectedFilters && self.selectedFilters.activity) {
                    self.searchParam.activity_id =  self.selectedFilters.activity;
                }
                else {
                    self.searchParam.activity_id = null;
                }
                if (self.selectedFilters && self.selectedFilters.fundingmechanism) {
                    self.searchParam.mechanism_id =  self.selectedFilters.fundingmechanism;
                }
                else {
                    self.searchParam.mechanism_id = null;
                }
                if (self.selectedFilters && self.selectedFilters.portfolio) {
                    self.searchParam.portfolio_id =  self.selectedFilters.portfolio;
                }
                else {
                    self.searchParam.portfolio_id = null;
                }

                self.tableDataDrilldown = [];
                self.isTblBusy = true;

                self.collapseMetaDataContainers();

                const response = await axios.post(encodeURI(`${BaseURL}/api/catalog/search`), self.searchParam);

                if  (response && response.status === 200) {
                    self.isDataRequested = false;
                    self.currentPage = 1;
                    self.tableData = [];
                    setTimeout(() => {
                        self.tableData = response.data;
                        self.isDataRequested = true;
                    }, 1);
                } else {
                    self.isDataRequested = true;
                    self.serviceFailure = true;
                }
                self.isTblBusy = false;
            }catch (error) {
                self.isTblBusy = false;
                self.serviceFailure = true;
            }
        },
        async showDrillDownData (dataRow, dataRowIndex) {
            if (!this.tableDataDrilldown || !this.tableDataDrilldown[dataRowIndex]) {
                try {
                let response = await axios.get(encodeURI(`${BaseURL}/api/catalog/fetchreportrelateddata?reportid=` + dataRow.report_Id + `&version=` + dataRow.version));

                if (response && response.status === 200) {
                    let data = response.data;

                    var formattedData = [];

                    formattedData.push({
                        ic: _.sortBy(data.ic, ["title"]),
                        portfolio: _.sortBy(data.portfolio, ["title"]),
                        mechanism: _.sortBy(data.mechanism, ["title"]),
                        activity: _.sortBy(data.activity, ["title"])
                    });
                    if (!this.tableDataDrilldown) {
                        this.tableDataDrilldown = [];
                    }
                    this.tableDataDrilldown[dataRowIndex] = formattedData;
                    return true;
                }
                } catch (err) {
                    return false;
                }
            } else {
                return true;
            }
        },
        clearSearchParams () {
            this.searchParam.activity_id = null;
            this.searchParam.ic_id = null;
            this.searchParam.mechanism_id = null;
            this.searchParam.portfolio_id = null;
            this.searchParam.variable_id = null;
            this.searchParam.topic_id = null;
            this.searchParam.year = null;

        },
        clearSearch () {
            var $this = this;

            this.clearSelectedFilters();
            this.clearSearchParams();
            this.responseMsg = "";
            this.isDataRequested = false;
            this.tableData = [];
            this.serviceFailure = false;
        },

        hideLoader () {
            var $this = this;

            setTimeout(() => {
                $this.isTblBusy = false;
            }, 101);
        },

        collapseMetaDataContainers () {
            _.forEach($(".collapsed-link.expanded"), (val) => {
                let id = $(val).prop('id').replace('tbl_row_id','');

                $(val).toggleClass('expanded');
                this.$root.$emit('bv::toggle::collapse', 'tbl_row' + id);
            });
        }
    },
};
</script>

<style lang="scss">
@import '@/scss/variables.scss';
    $slide-speed: 1s;

    #dashboard-content {
        // width: calc(100% - #{$sidebar-width});
        // width: calc(100% - 50px);
        width: 100%;
        margin: 0 auto;
        padding: $home-page-padding 0;
        min-height: 300px;
        // padding-left: 250px;
        transition: 0.5s;
        max-width: 1400px;
        // float: left;
        overflow: hidden;

        .filters-container {
            background-color: #f4f4f4;
            border-radius: 5px;
            box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
            .label-dropdown {
                font-size: 1rem;
                text-align: right;
                padding-right: 10px;
                vertical-align: top;
                font-weight: 600;
                color: #666;
                margin-bottom: 15px;
                line-height: 1.25rem;
            }
        }

        @media screen and (min-width: 992px) {
            .reportTitle {
                width: 45%;
            }
        }

        .records {
            display: inline-block;
            vertical-align: middle;
            line-height: 3em;
        }
    }

</style>
